import React from "react";
import * as styles from "./detail-modal-loading.module.scss";
import LoadingDots from "../../elements/loading-dots";
import whitelabel from "../../whitelabel";

/// A loading component for the contents of an asset detail modal
export default function DetailModalLoading() {
	return (
		<div className={styles.loadingContainer}>
			<LoadingDots color={whitelabel.palette.secondary500} />
		</div>
	);
}
